export const PrimaryColorsData = [
	{
		classNameLink: "color-1",
	},

	{
		classNameLink: "color-2",
	},

	{
		classNameLink: "color-3",
	},

	{
		classNameLink: "color-4",
	},

	{
		classNameLink: "color-5",
	},

	{
		classNameLink: "color-6",
	},
];

export const BackgroundColorsData = [
	{
		classNameLinkB: "bg-1",
	},

	{
		classNameLinkB: "bg-2",
	},
];
